export default function PlusCircleIcon(props) {

    let iconColor = props.active ? '#b60072' : '#ABABAB'
    return  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <circle cx="15" cy="15" r="15" fill={iconColor}/>
                <path d="M9.25 16.25h4.25a.25.25 0 0 1 .25.25v4.25a1.25 1.25 0 0 0 2.5 0V16.5a.25.25 0 0 1 .25-.25h4.25a1.25 1.25 0 0 0 0-2.5H16.5a.25.25 0 0 1-.25-.25V9.25a1.25 1.25 0 0 0-2.5 0v4.25a.25.25 0 0 1-.25.25H9.25a1.25 1.25 0 0 0 0 2.5z" fill="#fff"/>
            </svg>
}